module.exports = __webpack_public_path__ + "img/Barel.a9f5d831.png";